/**
 * Configuration for DesertHealthNews frontend.
 */
const jobiqoAppConfig = require('../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'us';
const locales = ['en'];

const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    SITENAME: 'DesertHealthNews',
    SITE_DESCRIPTION: 'The Coachella Valley’s Leading Resource for Health and Wellness',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    ASSETS: {
      logo: '/static/deserthealthnews/logo.png',
      faviconsPath: '/static/deserthealthnews',
    },
    OG_IMAGE: '/static/deserthealthnews/logo.png',
    THEME: {
      colors: {
        primary: '#09803e',
        secondary: '#e37f2a',
      },
    },
    BLOG_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ', 'G-NKJ9094JPS'],
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    PRICE_CONFIG: priceConfig,
  },
});
